export const DEFAULT_MAP_CENTER = {
  lat: 40.4023728,
  lng: -3.7130593
}

export const DEFAULT_ZOOM = 7
